import { FC } from 'react';
import { Box } from '@qga/roo-ui/components';
import LineItem from 'components/LineItem';
import type { SelfServiceAPI } from 'types';

const QantasTravelPassLineItem: FC<SelfServiceAPI.PaymentMethodBreakdown> = ({ total, paymentMethods }) => (
  <LineItem title="Qantas TravelPass" totals={[total]}>
    {(paymentMethods as SelfServiceAPI.QantasGroupCreditVoucherPaymentMethod[]).map((qantasTravelPass, index) => (
      <Box key={index} aria-label="Refund to Qantas TravelPass">
        Refund will be made to <strong>Qantas TravelPass {qantasTravelPass.cardNumber}</strong>
      </Box>
    ))}
  </LineItem>
);

export default QantasTravelPassLineItem;
